import React from "react";
import { errorToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
import PageHeader from "./common/pageheader";
import moment from "moment";

export default class TeamList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      Activestatus: "2",
      tableData: [],
      apiresponse: "",
    };
  }
  componentDidMount() {
    this.GetTeamList();
  }
  async GetTeamList() {
    let jsoninput = {
      fromdate: this.state.fromDate
        ? moment(this.state.fromDate).format("MM/DD/YYYY")
        : "",
      todate: this.state.toDate
        ? moment(this.state.toDate).format("MM/DD/YYYY")
        : "",
      Activestatus: this.state.Activestatus
    };
    let url = "GetHirachyTable.asp";
    let res = await ApiRequest(url, "POST", jsoninput, {
      Authorization: localStorage.getItem("token"),
    });
    console.log(res);
    this.setState({
      apiresponse: res,
    });
    if (res.status === "error") {
      if (res.message === "Session Expired") {
        errorToast(res.message);
        localStorage.clear();
        this.props.history.push("/login");
      }
      this.setState({
        tableData: [],
      });
      return;
    }
    this.setState({
      tableData: res.items,
    });
  }
  render() {
    return (
      <div>
        <PageHeader title="Team List" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3
                  className="card-title text-color-1"
                  style={{ fontWeight: "200", fontSize: "22px" }}
                >
                  Team List
                </h3>
              </div>
              <div className="d-md-flex mt-4 mb-2">
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fe fe-calendar"></i>
                        </span>
                      </span>
                      <input
                        type="date"
                        className="form-control daterange-single"
                        id="start_date"
                        name="start_date"
                        placeholder="From Date"
                        autoComplete="off"
                        onChange={(e) => {
                          this.setState({
                            fromDate: e.target.value,
                          });
                        }}
                        value={this.state.fromDate}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fe fe-calendar"></i>
                        </span>
                      </span>
                      <input
                        type="date"
                        className="form-control daterange-single"
                        id="end_date"
                        name="end_date"
                        placeholder="To Date"
                        autoComplete="off"
                        onChange={(e) => {
                          this.setState({
                            toDate: e.target.value,
                          });
                        }}
                        value={this.state.toDate}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="input-group">
                      <select
                        className="form-control daterange-single"
                        onChange={(e) => {
                          this.setState({
                            Activestatus: e.target.value,
                          });
                        }}
                        value={this.state.Activestatus}
                      >
                        <option value="0">Inactive</option>
                        <option value="1">Active</option>
                        <option value="2">All</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 text-left">
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn primebtn"
                      onClick={() => {
                        this.GetTeamList();
                      }}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                    style={{ textAlign: "center" }}
                  >
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Member ID</th>
                        <th>Sponsor ID</th>
                        <th>Date</th>
                        <th>BV</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.tableData.length <= 0 && !this.state.apiresponse.memberid1 ? (
                        <tr>
                          <td colSpan="6">No Details Found</td>
                        </tr>
                      ) : (
                        this.state.tableData.map((item, index) => (
                          <tr key={index}>
                            <td className="tabletd">{index + 1}</td>
                            <td>{item.memberid}</td>
                            <td>{item.sponsor}</td>
                            <td>{item.jdate}</td>
                            <td>{item.BV}</td>
                            <td>{item.Status}</td>
                          </tr>
                        ))
                      )}
                      {this.state.apiresponse.memberid1 ? (
                        <tr>
                          <td className="tabletd">
                            {this.state.tableData.length + 1}
                          </td>
                          <td>{this.state.apiresponse.memberid1}</td>
                          <td>{this.state.apiresponse.sponsor1}</td>
                          <td>{this.state.apiresponse.jdate1}</td>
                          <td>
                            {this.state.apiresponse.BV1
                              ? this.state.apiresponse.BV1
                              : "-"}
                          </td>
                          <td>{this.state.apiresponse.Status}</td>
                        </tr>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
